import React, { useEffect } from 'react';
import styled from 'styled-components';
import BasePageContainer from '../../components/BasePageContainer';
import Header from '../../components/Header';
import { fadeIn } from '../../styles';
import CustomText from '../../components/CustomText';
import { useParams } from 'react-router-dom';
import { policies, Policy } from './Policies';

const Container = styled(BasePageContainer)`
    background: #111;
    min-height: 100vh;
    width: 100vw;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10% 22% 3% 22%;
    box-sixing: border-box;

    opacity: 0;
    animation: ${fadeIn} 0.5s ease-in-out forwards;

    @media (min-width: 1024px) and (max-width: 1439px) {
        padding: 7% 22% 3% 22%;
    }

    div {
        display: flex;
        flex-direction: column;
    }

    a {
        color: salmon;
    }
`

const Privacy = () => {

    const { projectId = 'caloric' } = useParams();

    const [policy, setPolicy] = React.useState<Policy | null>(null);

    useEffect(() => {
        const data = policies[projectId];
        if (data) {
            setPolicy(data);
        }
    }, [projectId]);

    return (
        <Container>
            <Header title='Aminos.Dev.Project' />

            <Wrapper>
                {/* Title */}
                <CustomText fontWeight="400" fontSize="1.5em" marginTop="15vh">
                    Privacy Policy
                </CustomText>
                <CustomText color="rgba(255, 255, 255, 0.9)" marginTop="1.5vh">
                    Effective Date: {policy?.effective_date}
                </CustomText>

                {/* Sections */}
                {policy?.sections.map((section, i) => (
                    <div key={i}>
                        <CustomText fontWeight="400" fontSize="1.5em" marginTop="5vh">
                            {section.title}
                        </CustomText>

                        {/* Optional top-level content */}
                        {section.content && (
                            <CustomText
                                color="rgba(255, 255, 255, 0.9)"
                                lineHeight="150%"
                                marginTop="1.5vh"
                            >
                                {section.content}
                            </CustomText>
                        )}

                        {/* Optional links */}
                        {section.links?.map((link, j) => (
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={j}
                                color="rgba(100, 170, 255, 0.9)"
                            >
                                {link.label}
                            </a>
                        ))}

                        {/* Optional subsections */}
                        {section.subsections?.map((sub, k) => (
                            <div key={k}>
                                <CustomText fontWeight="500" fontSize="1.2em" marginTop="3vh">
                                    {sub.title}
                                </CustomText>
                                <CustomText
                                    color="rgba(255, 255, 255, 0.9)"
                                    lineHeight="150%"
                                    marginTop="1vh"
                                >
                                    {sub.content}
                                </CustomText>

                                {sub.links?.map((link, l) => (
                                    <a
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        key={l}
                                        color="rgba(100, 170, 255, 0.9)"
                                    >
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        ))}
                    </div>
                ))}

                {/* Contact */}
                <CustomText fontWeight="400" fontSize="1.5em" marginTop="5vh">
                    Contact
                </CustomText>
                <CustomText color="rgba(255, 255, 255, 0.9)" marginTop="1.5vh">
                    If you have any questions or suggestions, email us at:{' '}
                    <a
                        href={`mailto:${policy?.contact_email}`}
                        style={{ color: 'rgba(100, 170, 255, 0.9)' }}
                    >
                        {policy?.contact_email}
                    </a>
                </CustomText>
            </Wrapper>
        </Container>
    )
}

export default Privacy;